import { API, authClient } from "../index";

export const postDivisa = (divisa) => {
  return authClient().post(`${API}/divisa`, divisa);
};

export const getDivisas = () => {
  return authClient().get(`${API}/divisa`);
};

export const getDivisaById = (id) => {
  return authClient().get(`${API}/divisa/${id}`);
};

export const updateDivisa = (id, divisa) => {
  return authClient().put(`${API}/divisa/${id}`, divisa);
};

export const deleteDivisa = (id) => {
  return authClient().delete(`${API}/divisa/${id}`);
};
